<template>
    <b-modal id="user_delete" ref="user_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="setTitle">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('user_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'user'" variant="danger" :click="deleteUser">Delete</state-button>

            <state-button size="sm" v-else variant="danger" :click="deleteComment">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../components/Common/StateButton";

export default {
    name: "UserDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'user', 'comment', 'mode',
    ],

    computed: {
        setTitle() {
            if (this.mode === 'user') {
                return 'Delete ' + this.user.data.attributes.name + '?';
            } else {
                return 'Delete comment?';
            }
        },
    },

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteUser() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteUser', this.user)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-user');

                            this.$notify('error filled', 'Success!', 'Deleted the user!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        deleteComment() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteUserComment', this.comment)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-comment');

                            this.$notify('error filled', 'Success!', 'Deleted the comment!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
